import React from "react";
import { Component } from "react";
import PropTypes from "prop-types";
import { has } from "lodash";
import { Progress } from "react-sweet-progress";

import QuestionLabel from "./question/QuestionLabel";
import HelperContent from "./helperContent/HelperContent";
import C from "../constants";
import { currentQuestion } from "../state/questionStates";
import attestivNet from "../lib/AttestivNet";
import serverApi from '../lib/serverApi';
import strings from "../resources/strings";

import "react-sweet-progress/lib/style.css";
import { _ } from "core-js";

const uuidv4 = require("uuid/v4/");
const appCfg = require("../config");

var hpot = false, // honey pot
    submitted = false,
    uploadPercentage = 0, totalUploaded = 0, totalToUpload = 0;

class Summary extends Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    constructRecordNameFromFormData() {
        let state = this.props.store.getState();
        let clientRequest = state.clientRequest;
        let questionSet = state.questionSet;
        let name = "", description, recordNameProps;

        // if there is no client request, then try to update the name from the form answer data
        if (!clientRequest &&
            "recordNameProperties" in questionSet &&
            questionSet.recordNameProperties &&
            questionSet.recordNameProperties.length > 0
        ) {
            recordNameProps = questionSet.recordNameProperties;
            for (let i = 0; i < recordNameProps.length; i++) {
                let parts = recordNameProps[i].split(".");
                let q = state.questionHistory.filter(ans => ans.questionID === parts[0]);
                if (q && q.length > 0 && q[0].fields) {
                    let f = q[0].fields.filter(field => field.fieldID === parts[1]);
                    if (f && f.length > 0 && f[0].value !== undefined && f[0].value !== null && f[0].value !== "") {
                        name += f[0].value;
                        if (i < recordNameProps.length - 1) {
                            name += " ";
                        }
                    }
                }
            }

            return name.trim() ? {name: name.trim(), description: description} : null;
        }

        return null;
    }

    uploadToRecord() {
        let self = this;
        let state = this.props.store.getState();
        let questionSet = state.questionSet;

        console.debug("Checking for existing record");
        serverApi.checkForExistingRecord(state).then(function(record) {
            let recordData = self.constructRecordNameFromFormData();
            if (!recordData) {
                recordData = {};
            }

            if (record) {
                console.debug("Record exists: " + record.referenceId);
                
                recordData.referenceId = record.referenceId;
                recordData.billableOperations = {
                    barcodeScans: _.get(state, "billableOperations.barcodeScans", 0),
                    textExtractions: _.get(state, "billableOperations.textExtractions", 0),
                    facialDetections: _.get(state, "billableOperations.facialDetections", 0)
                };
                attestivNet
                    .updateRecord(recordData)
                    .then(function(response) {
                        console.debug(response);
                        console.debug("Record Name Updated");
                        self.commitAssets();
                    })
                    .catch(function(error) {
                        alert(strings.getString("recordUpdateFailed", _.get(error, "message", _.get(error, "response.data.message"))));
                        self.logout();
                    });
            }
            else {
                console.debug("Creating record");
                let createRecordData = recordData.name ? recordData : serverApi.createRecordInfo(state);
                attestivNet
                    .createRecord(createRecordData.name, questionSet.name, createRecordData.description, state.requestId, state.recordId)
                    .then(function(response) {
                        console.log(response);
                        // add recordId to state
                        console.debug("Record Created");
                        self.props.store.dispatch({ type: C.CREATE_SVR_RECORD, recordId: response.referenceId });

                        recordData.referenceId = response.referenceId;
                        recordData.billableOperations = {
                            barcodeScans: _.get(state, "billableOperations.barcodeScans", 0),
                            textExtractions: _.get(state, "billableOperations.textExtractions", 0),
                            facialDetections: _.get(state, "billableOperations.facialDetections", 0)
                        };
                        attestivNet
                            .updateRecord(recordData)
                            .then(function(response) {
                                console.debug(response);
                                console.debug("Record Name Updated");
                                self.commitAssets();
                            })
                            .catch(function(error) {
                                alert(strings.getString("recordUpdateFailed", error.response.data.message));
                                self.logout();
                            });
                    })
                    .catch(function(error) {
                        alert(strings.getString("recordCreationFailed", error.response.data.message));
                        self.logout();
                    });
            }
        });
    }

    async commitAssets() {
        let self = this;
        let store = self.props.store;
        let state = self.props.store.getState();
        let loc = "location" in state && state.location ? state.location : undefined;

        let assetData = {
            uuid: uuidv4(),
            recordId: state.recordId,
            referenceId: state.referenceId,
            requestId: state.requestId,
            workflowSessionId: state.workflowSession.workflowSessionId,
            startTime: state.startTime,
            timestamp: (new Date()).getTime(),
            location: loc ? loc.coords.latitude + "," + loc.coords.longitude : strings.getString("unknownLocation"), // location of where image is uploaded from and not necessarily location of where image was taken
            media: [] // setting this to empty or not setting it at all will cause the server to assemble the media items that were submitted
        };
        if (loc && loc.coords) {
            if (loc.coords.accuracy) {
                assetData.locationAccuracy = loc.coords.accuracy;
            }
            if (loc.coords.altitude) {
                assetData.altitude = loc.coords.altitude;
            }
        }

        console.debug("Committing assetData: " + JSON.stringify(assetData, null, 4));
        attestivNet
            .commitAssets(assetData)
            .then(function(response) {
                console.log(response);
                if (response.taskId && response.taskId.length > 0) {
                    console.log("Asset data uploaded.");
                    store.dispatch({ type: C.NEXT_QUESTION });
                } else {
                    console.debug("Asset data upload failed.");
                    self.logout();
                }
            })
            .catch(function(error) {
                alert(strings.getString("assetDataUploadFailed", (has(error.response, "data.message") ? ": " + error.response.data.message : "")));
                self.logout();
            });
    }

    postLogin(response, self) {
        if (response.status === "Success") {
            console.debug("Logged in. Creating Record. " + JSON.stringify(response));
            self.uploadToRecord();
        } else {
            console.debug("Log in failed. " + JSON.stringify(response));
        }
    }

    postLoginError(error, response, self) {
        console.error(error);
        self.props.store.dispatch({ type: C.STOP_LOADING });
    }

    login() {
        let self = this;
        let state = this.props.store.getState();

        console.debug(state.clientRequest ? "Logging in with requestId" : "Logging in with workflow");
        if (state.clientRequest) {
            attestivNet
                .loginWithRequestId(state.requestId)
                .then(function(response) {
                    self.postLogin(response, self);
                })
                .catch(function(error, response) {
                    self.postLoginError(error, response, self);
                });
        } else {
            attestivNet
                .loginWithWorkflow(state.questionSet.referenceId, state.organization)
                .then(function(response) {
                    self.postLogin(response, self);
                })
                .catch(function(error, response) {
                    self.postLoginError(error, response, self);
                });
        }
    }

    logout(selfParam, didCompleteSuccessfully) {
        let self = selfParam ? selfParam : this;

        attestivNet.logout()
            .then(function(response) {
                console.debug(response);
                console.debug(response.status === "Success" ? "Logout Successful" : JSON.stringify(response));
                self.props.store.dispatch({ type: C.STOP_LOADING });
                if (didCompleteSuccessfully === undefined || didCompleteSuccessfully) {
                    self.props.store.dispatch({ type: C.NEXT_QUESTION });
                }
            })
            .catch(function(error) {
                console.error(error);
                self.props.store.dispatch({ type: C.STOP_LOADING });
            });
    }

    startSubmit(store, state) {
        let self = this;

        console.debug("Start submit");
        let message = strings.getString("connecting");
        store.dispatch({ type: C.START_LOADING, loadingText: message });
        store.dispatch({ type: C.UPDATE_FILE_UPLOAD_PROGRESS, loadingText: message });

        let loggedInFunction = state.clientRequest
            ? attestivNet.loggedInWithRequestId
            : attestivNet.loggedInWithWorkflow;
        console.debug(state.clientRequest ? "Checking if logged in with client request" : "Checking if logged in with workflow");
        loggedInFunction()
            .then(
                response => {
                    console.log(response);
                    if (response.status === "Success") {
                        console.debug("Already logged in. Creating record.");
                        self.uploadToRecord();
                    } else {
                        console.debug("Not logged in. Logging in.");
                        self.login();
                    }
                },
                error => {
                    console.log(error);
                    alert(strings.getString("unableToConnectToServer"));
                    store.dispatch({ type: C.STOP_LOADING });
                }
            )
            .catch(function(error) {
                console.log(error);
                alert(strings.getString("unableToConnectToServer"));
                store.dispatch({ type: C.STOP_LOADING });
            });

    }

    handleSubmit() {
        console.debug("Submit clicked");
        let self = this;

        let hpot = document.getElementById("hpot");
        if (hpot.value.length > 0) {
            hpot = true;
            document.getElementById("submitButton").disabled = true;
            console.debug(strings.getString("submissionBlocked"));
            alert(strings.getString("submissionBlocked"));
            return;
        }

        submitted = true;

        let store = this.props.store;
        let state = store.getState();
        console.debug("Starting submission");
        self.startSubmit(store, state);
    }

    assembleThumbnailImages(state) {
        let thumbnailImages = [];
        let keyCount = 0;

        if (!state.questionHistory) {
            return thumbnailImages;
        }

        state.questionHistory.forEach(answer => {
            if ((has(answer, "filepath") && has(answer, "fileType")) || (has(answer, "tamperedMedia") && !has(answer, "filepath") && !has(answer, "fileType")))
                //&& (!includes(answer.tags, "recapturedPhoto")) && (!includes(answer.tags, "stockPhoto"))) // commented out so we always show all images
            {
                let fileType = answer.fileType;
                if (fileType && fileType.startsWith("image/")) {
                    if (has(answer, "file") && answer.file) {
                        thumbnailImages.push(
                            <div key={keyCount++} className="w3-col s4 w3-center">
                                <img className="thumbnailImage" src={URL.createObjectURL(answer.file)} alt="Thumbnail"/>
                            </div>
                        );
                    }
                    else if (has(answer, "filepath") && answer.filepath) { // if the workflow was resumed, then the image will not be in memory. We need to load it from a url.
                        thumbnailImages.push(
                            <div key={keyCount++} className="w3-col s4 w3-center">
                                <img className="thumbnailImage" src={state.defaultFileStorageUrlPrefix + answer.filepath} alt="Thumbnail"/>
                            </div>
                        );
                    }
                }
                else if (fileType && (fileType.startsWith("video/") || fileType.startsWith("audio/"))) {
                    thumbnailImages.push(
                        <div key={keyCount++} className="w3-col s4 w3-center">
                            <img className="thumbnailImage" src={appCfg.serverUrl + "/images/video-play-arrow.png"} alt="Thumbnail"/>
                        </div>
                    );
                }
                else if (fileType && fileType === "application/pdf") {
                    thumbnailImages.push(
                        <div key={keyCount++} className="w3-col s4 w3-center">
                            <img className="thumbnailImage" src={appCfg.serverUrl + "/images/pdf-icon.png"} alt="Thumbnail"/>
                        </div>
                    );
                }

                if (has(answer, "tamperedMedia") && answer.tamperedMedia.length > 0 && !has(answer, "filepath") && !has(answer, "fileType")) {
                    answer.tamperedMedia.forEach(tamperedMedia => {
                        if (has(tamperedMedia, "file") && tamperedMedia.file) {
                            thumbnailImages.push(
                                <div key={"tm" + keyCount++} className="w3-col s4 w3-center">
                                    <img className="thumbnailImage" src={URL.createObjectURL(tamperedMedia.file)} alt="Thumbnail"/>
                                </div>
                            );
                        }
                        else if (has(tamperedMedia, "filepath") && tamperedMedia.filepath) {
                            thumbnailImages.push(
                                <div key={"tm" + keyCount++} className="w3-col s4 w3-center">
                                    <img className="thumbnailImage" src={state.defaultFileStorageUrlPrefix + tamperedMedia.filepath} alt="Thumbnail"/>
                                </div>
                            );
                        }
                    });
                }
            }
        });

        return thumbnailImages;
    }

    getProgressInformation(state) {
        if (state.fileUploadsInProgress <= 0 && state.backgroundRequestsInProgress <= 0) {
            return null;
        }

        let suffix = state.fileUploadsInProgress === 1 ? strings.getString("fileRemainingToUpload") : strings.getString("filesRemainingToUpload");

        let maxBackgroundRequestsInProgress =  state.maxBackgroundRequestsInProgress > 0 ? state.maxBackgroundRequestsInProgress : 1;
        let backgroundProcessPct = ((state.maxBackgroundRequestsInProgress - state.backgroundRequestsInProgress) / maxBackgroundRequestsInProgress) * 100;

        let debugEnabled = "REACT_APP_DEBUG" in process.env && process.env.REACT_APP_DEBUG === "true" ? true : false

        let backgroundProgressBar = debugEnabled ? (<div>{state.backgroundRequestsInProgress + " of " + state.maxBackgroundRequestsInProgress + " background tasks remaining"}
                <Progress percent={backgroundProcessPct}/></div>) : null;
        let progressBar = state.fileUploadsInProgress > 0 ? (<Progress percent={uploadPercentage}/>) : null;

        return (<div className="w3-padding-16">
                    {backgroundProgressBar}
                    {state.fileUploadsInProgress > 0 ? state.fileUploadsInProgress + suffix : ""}
                    {progressBar}
                    {state.fileUploadsInProgress > 0 ? totalUploaded + "/" + totalToUpload + " bytes" : ""}<br/>
                </div>);
    }

    toggleSubmitButton(state) {
        let submitButton = document.getElementById("submitButton");
        let verificationCheckbox = document.getElementById("verification");
        if (!verificationCheckbox || !submitButton  || state.failedFileUploads > 0) {
            console.debug("No verification checkbox or submit button element found or there are failed file uploads");
            return;
        }

        // don't enable if files are still uploading or there are background requests (triage/objectDetection) still pending
        if (state.fileUploadsInProgress <= 0) {
            console.debug(verificationCheckbox.checked ? "Enable submit button" : "Disable submit button");
            submitButton.disabled = !verificationCheckbox.checked;
            this.forceUpdate();
        }
        else if (state.fileUploadsInProgress > 0) {
            console.debug("fileUploadsInProgress is greater than 0");
        }
        else if (state.backgroundRequestsInProgress > 0) {
            console.debug("backgroundRequestsInProgress is greater than 0");
        }
    }

    isSubmitButtonDisabled() {
        let el = document.getElementById("submitButton");
        return el ? el.disabled : true;
    }

    componentDidMount() {
        let self = this;

        attestivNet.setUploadProgressFunction(function(percentage, totalLoaded, totalToLoad, loaded, total) {
            uploadPercentage = percentage;
            totalUploaded = totalLoaded;
            totalToUpload = totalToLoad;
            self.forceUpdate();
        });

        let interval = setInterval(function() {
            let state = self.props.store.getState();
            if (state.fileUploadsInProgress <= 0) {
                clearInterval(interval);
                if (state.failedFileUploads > 0) {
                    alert(strings.getString("filesFailedToUpload"));
                }
                self.toggleSubmitButton(state);
            }
        }, 2000);
    }

    render() {
        if (hpot) {
            return null;
        }

        let state = this.props.store.getState();
        let current = currentQuestion(state);

        // once submitted, we want to hide all the form information
        if (submitted) {
            let className = "w3-header" + (has(current, "class") ? " " + current.class : " w3-center");
            return (<div className="form w3-header w3-animate-opacity">
                <div className="w3-header w3-center">
                    <h2>{strings.getString("reviewAndSubmit")}</h2>
                    <div className={className} dangerouslySetInnerHTML={{__html: current.questionLabel}}></div>
                </div>
            </div>);
        }

        let thumbnailImages = this.assembleThumbnailImages(state);
        let submitButtonDisabled = this.isSubmitButtonDisabled();
        let progressInformation = this.getProgressInformation(state);
        let buttonClasses = "w3-button w3-block w3-round-xxlarge w3-large w3-padding-large";

        buttonClasses += " " + _.get(current, "buttonColorClass", "w3-indigo");

        return (
            <div className="form w3-header w3-animate-opacity">
                <div className="w3-header w3-center">
                    <h2>{strings.getString("reviewAndSubmit")}</h2>
                    <QuestionLabel question={current} store={this.props.store}/>
                    <HelperContent question={current}/>
                </div>

                <div className="w3-row">{thumbnailImages}</div>

                {state.questionHistory.map((answer, i) => {
                    let bullets = [], j = 0;
                    
                    if (answer.questionType === "form") {
                        answer.fields.forEach(field => {
                            if (field.fieldType !== "hidden" || field.fieldID === "facialMatch") {
                                bullets.push(<li key={j}>
                                    {field.label}: {field.value}
                                </li>);
                                j++;
                            }
                        });
                    }
                    
                    /*if (answer.facialDetectionResult) {
                        bullets.push(<li key={j}>
                            Facial Match: {answer.facialDetectionResult.length > 0 ? "Yes - " + answer.facialDetectionResult[0].similarity.toFixed(2) + "% similar" : "No"}
                        </li>);
                        j++;
                    }*/

                    if (bullets.length > 0) {
                        let keyName = "summaryUL-" + i;
                        return <ul key={keyName}> {bullets} </ul>;
                    }

                    return <div key={i} />;
                })}

                {progressInformation}

                <input type="hidden" id="hpot" name="Name" value=""/>

                <input id="verification" type="checkbox" name="verification" value="Verified" onChange={(evt) => this.toggleSubmitButton(state)}/>
                <label htmlFor="verification">
                    &nbsp;{strings.getString("verificationMessage")}&nbsp;
                    <a className="w3-medium w3-text-blue" href={strings.getString("termsOfServiceURL")} target="_blank" rel="noopener noreferrer">
                        {strings.getString("termsOfService")}
                    </a>.
                </label>
                <br/><br/>
                <button id="submitButton" className={buttonClasses}
                        disabled={submitButtonDisabled} onClick={(evt) => this.handleSubmit(evt)}>{_.has(current, "submitButtonLabel") ? current.submitButtonLabel : strings.getString("submit")}</button>
            </div>
        );
    }
}

Summary.propTypes = {
    allQuestions: PropTypes.array
};

export default Summary;
